import { render, staticRenderFns } from "./trademark-lookout.vue?vue&type=template&id=54d74a04&scoped=true&"
import script from "./trademark-lookout.vue?vue&type=script&lang=js&"
export * from "./trademark-lookout.vue?vue&type=script&lang=js&"
import style0 from "./trademark-lookout.vue?vue&type=style&index=0&id=54d74a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d74a04",
  null
  
)

export default component.exports